import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import {
  AiFillGithub,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

const iconHover = {
  scale: 1.15,
  transition: { type: "spring", stiffness: 400, damping: 15 },
};

const Footer = () => {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row className="align-items-center">
        <Col md="4" className="footer-copywright">
          <span>Stay Hungry, Stay Foolish</span>
        </Col>
        <Col md="4" className="footer-copywright">
          <span>Copyright © {year} | बंटी चक्रवर्ती</span>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <motion.a
                href="https://github.com/buntychakraborty"
                style={{ color: "rgba(255,255,255,0.4)" }}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="github"
                whileHover={iconHover}
              >
                <AiFillGithub />
              </motion.a>
            </li>

            <li className="social-icons">
              <motion.a
                href="https://www.linkedin.com/in/bunty-chakraborty-b5a395119/"
                style={{ color: "rgba(255,255,255,0.4)" }}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="linkedin"
                whileHover={iconHover}
              >
                <FaLinkedinIn />
              </motion.a>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
};

export default Footer;
